// Package imports:
import React from 'react';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type OpeningHoursType = 'kaupholl' | 'markadur';

interface IProps {
    type: OpeningHoursType,
}

const OpeningHours: React.FC<IProps> = ({
    type,
}) => {
    return (
        <div className="KCL_opening-hours">
            <FontAwesomeIcon icon={faClock} className="icon-fa" />
            <div>
                {(type === 'kaupholl') 
                    ? <span className='opening-hours-text'>Kauphöll er opin <strong>milli kl. 09:30 og 15:30</strong> á bankadögum.</span>
                    : (type === 'markadur')
                    ? <span className='opening-hours-text'>Markaðurinn er opinn <strong>milli kl. 09:15 og 16:00</strong> á bankadögum.</span>
                    : null
                }
                <span>Bankadagar eru virkir dagar þegar bankar eru opnir á Íslandi.</span>
            </div>
        </div>
    )
}

export default OpeningHours;
